module.exports = __webpack_public_path__ + "media/若依好像…… 在很高的地方，看过这样的光_可丽.fbfab172.wav";